/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CarIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABNklEQVR4nN2TO04EMQxAAzRwEZYrgEA0W05sC2nWnmpLKOAIy9yGLaCDE7DiFEAJWyFOgECZCSKaSUgGohXCkov492wnUepfSlmWW0B8DiT3GvkNSN59an0mZnY4nW6mFt/QyDehohBSlOu6rtejAE2Mtrvngqrd75KMD5H3AGXZQEAgDkCZNwDi06SR25yztimZp0zwZIKJeDsVAFCO7JqWSqm1YGBxVO18rie1eLcxU0OFBEhO2k74Qg0UbVdrakSDEKvjoQCwzXnvQZPcDX6WFHu2vPiiIy9yAzTJbWdEvspXnC89a+LXbACUF98lNU7zM825oGq/a3PF53dtQYAJMmdEPujaXPH5XVsQkEvV6gHIjxkv+aEPgMk42wQwGfcA7prUDwVi+eZH936gGgD4Zf7flA8k9fADjn9IYQAAAABJRU5ErkJggg==)
 */
export const CarIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M4.46 5.03A4 4 0 0 1 8.34 2h7.32a4 4 0 0 1 3.88 3.03L20.78 10H22a1 1 0 1 1 0 2h-.54c.35.59.54 1.27.54 2v4a2 2 0 0 1-1 1.73V21a1 1 0 1 1-2 0v-1H5v1a1 1 0 1 1-2 0v-1.27A2 2 0 0 1 2 18v-4c0-.73.2-1.41.54-2H2a1 1 0 1 1 0-2h1.22l1.24-4.97Zm13.14.48L18.72 10H5.28L6.4 5.51A2 2 0 0 1 8.34 4h7.32a2 2 0 0 1 1.94 1.51ZM10 14a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-6 1a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm14-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
